import { render, staticRenderFns } from "./ApplicantPage.vue?vue&type=template&id=0db91b11&scoped=true"
import script from "./ApplicantPage.vue?vue&type=script&lang=js"
export * from "./ApplicantPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db91b11",
  null
  
)

export default component.exports